module.exports = __webpack_public_path__ + "img/logoblue.16e31725.png";